import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, computed, ref } from 'vue'

import ErrorDialog from '@/components/parts/common/ErrorDialog.vue'
import Loading from '@/components/parts/common/Loading.vue'

import { DIALOG_ERROR_INFO } from '@/mixins/commonFunction'
import { deleteGroupInfo } from '@/mixins/communicationFunction'
import { toHexNumber } from '@/utils/math'

import { ErrorDialogInfo, GroupListStore } from '@/types/Interfaces'

// ==================================
// interface
// ==================================
interface Props {
  dialog: {
    isDialog: boolean;
    item: GroupListStore;
  }
}

interface Emits {
  (e: 'show-error-dialog', result: boolean, title: string, message: string): void;
  (e: 'dialogClose'): void;
}

// ==================================
// data
// ==================================

export default /*@__PURE__*/_defineComponent({
  __name: 'GroupDeleteDialog',
  props: {
    dialog: {}
  },
  emits: ["show-error-dialog", "dialogClose"],
  setup(__props: any, { emit: __emit }) {

/**
 * GroupDeleteDialog.vue
 * グループ削除
 * 
 * 親コンポーネント
 * @/views/GroupSetting.vue
 */
// ==================================
// import
// ==================================
const props = __props

// ローディングアイコン表示判定
const isLoading = ref<boolean>(false,)

// グループ情報
const groupInfo = ref<GroupListStore>({
  groupid: 0,
  groupname: ''
})

const errDialog = ref<ErrorDialogInfo>({
  isShow: false,
  title: '',
  message: ''
})

// ==================================
// computed
// ==================================
// ダイアログの表示判定用
const isDialog = computed(() => {
  return props.dialog.isDialog
})

// ==================================
// hook
// ==================================
onBeforeMount(() => {
  initialize()
})

// ==================================
// method
// ==================================
const emit = __emit

/**
 * 初期処理
 */
const initialize = () => {
  groupInfo.value.groupid = props.dialog.item.groupid
  groupInfo.value.groupname = props.dialog.item.groupname
}

/**
 * グループ情報削除処理
 */
const onClickDelete = () => {
  isLoading.value = true
  // グループ削除APIを呼び出す
  let promise = deleteGroupInfo(groupInfo.value.groupid)
  promise
    .then(() => {
      isLoading.value = false
      emit('show-error-dialog', true, 'グループ削除成功','グループを削除しました。\nグループID: ' + toHexNumber(groupInfo.value.groupid) + '、グループ名: ' + groupInfo.value.groupname)
    })
    .catch(() => {
      isLoading.value = false
      // エラーメッセージを設定する
      let title = DIALOG_ERROR_INFO.title.deleteError
      let message = DIALOG_ERROR_INFO.message.deleteErrorGroupInfo
      emit('show-error-dialog', false, title, message)
    })
}

/**
 * ダイアログ閉じる処理
 */
const dialogClose = () => {
  emit('dialogClose')
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isDialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDialog).value = $event)),
    class: "group-delete-dialog",
    width: "400px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, {
                class: "group-delete-dialog__title",
                nav: "",
                density: "compact"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" グループ削除 ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("以下のグループを削除してもよろしいですか？")
                ])),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(groupInfo.value.groupname), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary darken-2",
                    class: "group-delete-dialog__delete-btn",
                    onClick: onClickDelete
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" 削除 ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "grey darken-2",
                    dark: "",
                    onClick: dialogClose
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" キャンセル ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ErrorDialog, { "error-dialog": errDialog.value }, null, 8, ["error-dialog"]),
      _withDirectives(_createVNode(Loading, null, null, 512), [
        [_vShow, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})